import styled from 'styled-components';

import { utils } from '@desygner/ui-common-components';

export const StyledCarousel = styled.div`
  ${({ theme }) => `
    width: 100%;
    display: flex;
    gap: ${utils.rem(theme.Spacing.Size.MediumLarge)};
    flex-direction: column;
    background-color: ${theme.Color.Neutrals.Paper}
  `}
`;

export const StyledCarouselLeftArrow = styled.div`
  ${({ theme }) => `
    z-index: ${theme.ZIndex.ZIndex.Elevated};
    left: -${utils.rem(theme.Spacing.Size.MediumSmall)};
    position: absolute;
  `}
`;

export const StyledCarouselRightArrow = styled.div`
  ${({ theme }) => `
    z-index: ${theme.ZIndex.ZIndex.Elevated};
    right: -${utils.rem(theme.Spacing.Size.MediumSmall)};
    position: absolute;
  `}
`;

export const StyledCarouseText = styled.div<{ isCentered?: boolean }>`
  ${({ theme, isCentered }) => `
    display: flex;
    align-items: baseline;
    justify-content: ${isCentered ? 'center' : 'space-between'};
    gap: ${utils.rem(theme.Spacing.Size.Small)};
  `}
`;

export const StyledCarouselSwiper = styled.div<{ height?: number }>`
  ${({ theme, height }) => `
    display: flex;
    align-items: center;
    position: relative;
    height: ${height ? utils.rem(height) : '100%'};


    & .swiper {
      width: 100%;
      height: 100%;
      color: red;

      & .swiper-slide {
        width: auto !important;
      }
    }


  `}
`;
